import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useGetBothChallanQuery } from "../../features/api/challan2Api";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import { PDFViewer } from "@react-pdf/renderer";
import { formatDate } from "../../components/CommonDateFormat";
import headerLogo from "../../asset/johura_logo.png";
import signature from "../../asset/signature.png";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "white",
    paddingBottom: "88pt",
  },
  header: {
    color: "white",
    marginBottom: 5,
    textAlign: "center",
    height: "3.8cm",
  },
  imgborder: {
    borderBottom: "1px solid green",
    paddingBottom: "5px",
    marginBottom: "3px",
  },
  HedingTextBorder: {
    borderBottom: "1px solid red",
  },

  invTitle: {
    textAlign: "center",
    backgroundColor: "#000",
    color: "white",
    padding: "4px 0px",
    fontSize: "12px",
    width: "70px",
    borderRadius: "2px",
    margin: "0 auto",
  },
  invoice: {
    padding: "10px 20px",
    fontSize: "10px",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  invLeft: {
    fontWeight: "bold",
    flexDirection: "column",
    gap: "4px",
  },
  invBottom: {
    fontSize: "11px",
    padding: "0 20 10 20",
    flexDirection: "column",
    gap: "8px",
  },

  footer: {
    color: "white",
    height: "2cm",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    marginTop: 20,
    textAlign: "center",
    flexDirection: "row",
    justifyContent: "center",
    fontSize: "12",
  },
  footerAddr: {
    height: "",
    color: "black",
    fontSize: "8px",
    margin: "13 auto",
    width: "100%",
    fontWeight: "thin",
  },
  footerBgc: {
    backgroundColor: "#006600",
    height: "0.8cm",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
  },
  table: {
    borderWidth: 1,
    marginHorizontal: 20,
    borderColor: "#D0D0D0",
    fontSize: "10",
    flexFlow: 1,
  },
  tableHeaderBg: {
    backgroundColor: "#aaa",
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCell: {
    borderBottomWidth: 1,
    borderRight: 1,
    borderColor: "#D0D0D0",
    textAlign: "center",
    padding: 6,
  },
  tableCellTitle: {
    marginBottom: 4,
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "center",
  },
  author: {
    fontSize: "10px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "20px",
    padding: "0 20px",
  },
  authorText: {
    borderTop: "1px solid black",
    paddingTop: "1px",
  },
  thanks: {
    fontSize: "11px",
    display: "flex",
    flexDirection: "column",
    marginTop: "30px",
    padding: "0 20px",
    gap: "5px",
  },
  thanksText: { marginBottom: "80px" },
  pageNumber: {
    position: "absolute",
    bottom: 55,
    right: 20,
    fontSize: 10,
  },
});

function ChallanReport() {
  // useRef for report
  const [visible, setVisible] = useState(false);
  const [isSignature, setIsSignature] = useState(false);

  const { chId } = useParams();

  const bothChallans = useGetBothChallanQuery(chId, {
    refetchOnMountOrArgChange: true,
  })?.data;
  const master = bothChallans?.master;
  const items = bothChallans?.items;

  return (
    <div className="px-6">
      <div className="flex gap-6 items-center my-2">
        <input
          onClick={() => setVisible(!visible)}
          type="checkbox"
          className="cursor-pointer"
        />
        <Link to="/dashboard/challan">Back</Link>
        <input
          onClick={() => setIsSignature(!isSignature)}
          type="checkbox"
          // defaultChecked
          className="cursor-pointer"
        />
        Signature
      </div>
      <PDFViewer style={{ width: "100%", height: "100vh" }}>
        <Document>
          <Page size="A4" style={styles.page}>
            {/* Header */}
            <View style={styles.header} fixed>
              {visible && (
                <View>
                  <View style={styles.imgborder}>
                    <Image src={headerLogo} />
                  </View>
                  <Text style={styles.HedingTextBorder}></Text>
                </View>
              )}
            </View>

            {/* Invoice */}
            <View>
              <Text style={styles.invTitle}>CHALLAN</Text>
              <View style={styles.invoice}>
                <View style={styles.invLeft}>
                  <Text>To</Text>
                  <Text>{master?.customer}</Text>
                  <Text>{master?.address}</Text>
                </View>
                <View>
                  <Text>Challan No: {master?.ch_no}</Text>
                  <Text> Date: {formatDate(master?.ch_date)}</Text>
                </View>
              </View>

              <View style={styles.invBottom}>
                <Text>Branch: {master?.branch}</Text>
              </View>

              <View style={styles.invBottom}>
                <Text>
                  <Text style={{ fontSize: "12px" }}>Sub:</Text> {master?.title}
                </Text>
                <Text
                  style={{
                    color: "black",
                    fontWeight: "extrabold",
                    margin: "3px 0px",
                  }}
                >
                  {master?.model_srl}
                </Text>
                <Text>{master?.ch_ref}</Text>
              </View>
            </View>

            {/* Table */}
            <View style={styles.table}>
              {/* Table Header */}
              <View
                style={{ ...styles.tableRow, ...styles.tableHeaderBg }}
                fixed
              >
                <View style={{ ...styles.tableCell, width: "10%" }}>
                  <Text>Sl No.</Text>
                </View>
                <View style={{ ...styles.tableCell, width: "70%" }}>
                  <Text>Description</Text>
                </View>
                <View
                  style={{ ...styles.tableCell, width: "20%", borderRight: 0 }}
                >
                  <Text>Quantity</Text>
                </View>
              </View>

              {/* Table Data */}
              {items?.map((data, index) => {
                return (
                  <View key={index} style={styles.tableRow}>
                    <View style={{ ...styles.tableCell, width: "10%" }}>
                      <Text>{index + 1}</Text>
                    </View>
                    <View
                      style={{
                        ...styles.tableCell,
                        width: "70%",
                        textAlign: "left",
                      }}
                    >
                      <Text>{data?.product}</Text>
                    </View>

                    <View
                      style={{
                        ...styles.tableCell,
                        width: "20%",
                        borderRight: 0,
                      }}
                    >
                      <Text> {data?.qty}pc</Text>
                    </View>
                  </View>
                );
              })}
            </View>

            <View style={styles.thanks}>
              <Text style={styles.thanksText}>Thanks for</Text>
              {isSignature && (
                <View>
                  <View
                    style={{
                      width: "100px",
                      marginTop: "-80px",
                      marginLeft: "-12px",
                    }}
                  >
                    <Image src={signature} />
                  </View>
                </View>
              )}
              <Text>Engr. Md Jahangir Alam</Text>
              <Text>Managing Director</Text>
              {/* <Text>JOHURA ENDOMED SOLUTION</Text> */}
            </View>
            <View style={styles.author} fixed>
              <Text>Prepared By: Johura Endomed Solution</Text>
            </View>

            {/* Page Number */}
            <View style={styles.pageNumber} fixed>
              <Text
                render={({ pageNumber, totalPages }) =>
                  `page ${pageNumber} of ${totalPages}`
                }
              />
            </View>

            {/* Footer */}
            <View style={styles.footer} fixed>
              {visible && (
                <View style={styles.footerAddr}>
                  <Text>
                    15/A Zigatola, Hafizullah Green Tower, Flat # C1, Dhanmondi,
                    Dhaka - 1209
                  </Text>
                  <Text>
                    Cell: 01711-071102, 01977-071102, 01778-874364, E-mail:
                    jahangirjohura@gmail.com / Web: www.johurabd.com
                  </Text>
                </View>
              )}
              {visible && <Text style={styles.footerBgc}></Text>}
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
}

export default ChallanReport;
